"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setHeaderData = exports.headerSlice = exports.fetchHeader = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const app_1 = require("../../Endpoints/app");
const initialState = {
    header: null
};
exports.fetchHeader = (0, toolkit_1.createAsyncThunk)('fetchHeaderData', ({ pageId, callback }) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, app_1.getHeaderData)(pageId);
    callback && callback();
    return response;
}));
exports.headerSlice = (0, toolkit_1.createSlice)({
    name: 'header',
    initialState,
    extraReducers: builder => {
        builder.addCase(exports.fetchHeader.fulfilled, (state, action) => {
            state.header = action.payload;
        });
    },
    reducers: {
        setHeaderData: (state, action) => {
            state.header = action.payload;
        }
    }
});
exports.setHeaderData = exports.headerSlice.actions.setHeaderData;
exports.default = exports.headerSlice.reducer;
